<template>
  <v-app-bar color="transparent" elevation="0">
    <v-toolbar-title class="d-none d-lg-block flex-wrap">
      <router-link :to="{ name: 'About' }">
        <img :src="$logos.page" alt="XTUR Sp. z o.o." />
      </router-link>
    </v-toolbar-title>
    <div class="localization">
      <span>{{ officeProfile }}</span>
    </div>
    <v-spacer></v-spacer>
    <div class="d-flex pb-3">
      <span
        v-for="(menuItem, index) in menuItems"
        :key="index"
        class="d-inline-flex"
        style="margin: 0 6px"
        :class="getMenuItemClass(menuItem)"
      >
        <router-link :to="menuItem.to" :title="menuItem.title">
          <v-icon small class="header-icon">{{ menuItem.icon }}</v-icon>
          {{ menuItem.name }}
        </router-link>
        <v-divider v-if="index < menuItems.length - 1" vertical style="margin: 0 0 0 10px" />
      </span>
      <span class="d-inline-flex ml-8">
        <router-link :to="{ name: 'Administration User Profile' }" :title="$i18n.t('userProfile') | capitalize">
          <v-icon small>$user</v-icon>
        </router-link>
        <v-divider vertical style="margin: 0 0 0 10px" />
      </span>
      <span class="d-inline-flex" style="margin: 0 8px 0 10px">
        <router-link :to="{ name: 'Logout' }" :title="$i18n.t('logout') | capitalize">
          <v-icon small>$logout</v-icon>
        </router-link>
      </span>
    </div>
  </v-app-bar>
  <!--  </header>-->
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Location } from "vue-router";
import { filterCapitalize } from "@/filters/capitalize";

interface MenuItem {
  name?: string;
  to: string | Location;
  icon: string;
  title?: string;
  urlComponent?: string;
}

const activeClasses = ["active-top-menu"];

@Component
export default class LayoutHeader extends Vue {
  get menuItems(): Array<MenuItem> {
    return [
      {
        name: filterCapitalize(this.$t("bookings")),
        urlComponent: "/bookings/",
        icon: "$bookings",
        to: { name: "Bookings" } as Location,
      },
      {
        name: filterCapitalize(this.$t("orders")),
        urlComponent: "/orders/",
        icon: "$orders",
        to: { name: "Orders" } as Location,
      },
      {
        name: filterCapitalize(this.$t("documents")),
        urlComponent: "/documents/",
        icon: "$documents",
        to: { name: "Documents" } as Location,
      },
      {
        name: filterCapitalize(this.$t("costs")),
        icon: "$dollarInCircle",
        to: { name: "Cost panel" } as Location,
      },
      {
        name: filterCapitalize(this.$t("finances")),
        urlComponent: "/finances/",
        icon: "$finances",
        to: { name: "Finances" } as Location,
      },
      {
        name: filterCapitalize(this.$t("reports")),
        icon: "$reports",
        to: { name: "Reports" } as Location,
      },
      {
        name: filterCapitalize(this.$t("accountancy")),
        icon: "$accountancy",
        to: { name: "Bookkeeping Optima" } as Location,
      },
      {
        name: filterCapitalize(this.$t("administration")),
        icon: "$settings",
        to: { name: "Administration" },
      },
    ];
  }

  getMenuItemClass(menuItem: MenuItem): Array<string> {
    if (typeof menuItem.to === "object") {
      if (typeof menuItem.to.name === "string") {
        const toNamedRoute: string = menuItem.to.name;
        if (typeof this.$route.matched.find((v) => v.name === toNamedRoute) !== "undefined") {
          return activeClasses;
        }
      }
      if (typeof menuItem.urlComponent === "string") {
        if (this.$route.path.includes(menuItem.urlComponent)) {
          return activeClasses;
        }
      }
    }
    return [];
  }

  get officeProfile(): string {
    return this.$store.direct.state.user.userOfficeProfiles.find((x) => x.isSelected)?.name ?? "";
  }
}
</script>

<style lang="scss" scoped>
header {
  padding: 0 10px 37px 27px;
  width: 100%;
  height: 47px !important;
}

.localization {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  padding-bottom: 4px;
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  font-family: metropolis-semi-bold;
  line-height: 1;
}

.header-icon {
  margin: -2px 4px 0 0;
}
</style>
